import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useState, useEffect } from 'react';
import { string, object, func, bool, shape, arrayOf, number, oneOfType } from 'prop-types';
import { Review, FilterItem } from '../../molecules';
import FilterItemContainer from '../FilterItemContainer';
import sortDescByValue from '../../utils/sortDescByValue';

const FilterItemReview = _ref => {
  let {
    fullScreen,
    label,
    position,
    filterSelected,
    items,
    onItemClick
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["fullScreen", "label", "position", "filterSelected", "items", "showFilterInput", "onItemClick"]);

  const [filterRating, setFilterRating] = useState(sortDescByValue(items));
  useEffect(() => {
    setFilterRating(items);
    return () => setFilterRating({});
  }, [items]);
  return /*#__PURE__*/React.createElement(FilterItemContainer, _extends({
    position: position,
    label: label,
    fullScreen: fullScreen,
    filterSelected: filterSelected && Object.keys(filterSelected).length ? /*#__PURE__*/React.createElement(Review, {
      min: 0,
      max: 5,
      score: filterSelected == null ? void 0 : filterSelected.value,
      label: filterSelected == null ? void 0 : filterSelected.hint,
      format: "label",
      fontSize: "14px",
      width: "20px",
      height: "20px"
    }) : undefined
  }, props), filterRating.map((item, idx) => /*#__PURE__*/React.createElement("ul", {
    key: (item == null ? void 0 : item.slug) || idx
  }, /*#__PURE__*/React.createElement(FilterItem, {
    onClick: onItemClick,
    item: item
  }, /*#__PURE__*/React.createElement(Review, {
    min: 0,
    max: 5,
    score: item == null ? void 0 : item.value,
    label: item == null ? void 0 : item.hint,
    format: "label",
    fontSize: "14px",
    width: "20px",
    height: "20px",
    "data-testid": "review-item"
  })))));
};

FilterItemReview.defaultProps = {
  filterSelected: [],
  items: [],
  showFilterInput: false,
  onItemClick: () => {},
  onClick: () => {}
};
process.env.NODE_ENV !== "production" ? FilterItemReview.propTypes = {
  label: string.isRequired,
  position: number,
  filterSelected: object,
  showFilterInput: bool,
  fullScreen: bool,
  items: arrayOf(shape({
    href: string,
    value: oneOfType([string, number]),
    selected: bool,
    hint: string
  })).isRequired,
  onItemClick: func,
  onClick: func
} : void 0;
export default FilterItemReview;